var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wizard_Completo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit",
    fill: "#7E8083",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6779149,1.29374468 C16.958766,-0.429659574 14.1630213,-0.429659574 12.4438723,1.29374468 L1.01408511,12.7192766 C0.924723404,12.8086383 0.869404255,12.9235319 0.852382979,13.0469362 L0.00557446809,19.3192766 C-0.0199574468,19.498 0.0438723404,19.6767234 0.167276596,19.8001277 C0.273659574,19.9065106 0.422595745,19.9703404 0.571531915,19.9703404 C0.59706383,19.9703404 0.622595745,19.9703404 0.64812766,19.9660851 L4.42685106,19.4554468 C4.74174468,19.4128936 4.96302128,19.1235319 4.92046809,18.8086383 C4.87791489,18.4937447 4.58855319,18.2724681 4.27365957,18.3150213 L1.24387234,18.7235319 L1.8353617,14.3490638 L6.43961702,18.9533191 C6.546,19.0597021 6.69493617,19.1235319 6.84387234,19.1235319 C6.99280851,19.1235319 7.14174468,19.0639574 7.24812766,18.9533191 L18.6779149,7.52778723 C19.5119574,6.69374468 19.9715319,5.5873617 19.9715319,4.4086383 C19.9715319,3.22991489 19.5119574,2.12353191 18.6779149,1.29374468 Z M12.6651489,2.698 L14.5842979,4.61714894 L4.15451064,15.0469362 L2.2353617,13.1277872 L12.6651489,2.698 Z M6.84812766,17.7362979 L4.97153191,15.8597021 L15.4013191,5.42991489 L17.2779149,7.30651064 L6.84812766,17.7362979 Z M18.0779149,6.48523404 L13.4864255,1.89374468 C14.0694043,1.41289362 14.7970638,1.14906383 15.5630213,1.14906383 C16.4353617,1.14906383 17.252383,1.48948936 17.8694043,2.10225532 C18.4864255,2.71502128 18.8225957,3.53629787 18.8225957,4.4086383 C18.8225957,5.17885106 18.558766,5.90225532 18.0779149,6.48523404 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.b026d51ef14638c7110db26c096e6be1.svg";
export { ForwardRef as ReactComponent };